import { VisualDepType } from "../../../types";

export const initVisual:VisualDepType = {
    visual: "cards"
}